// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"c34adfd3","78":"b30d6c8f","87":"fa05d738","242":"c1780ef2","355":"37e6f5e7","396":"55d7de20","441":"e55773da","470":"33a6b278","662":"198c9fa1","809":"b00f853d","856":"652220ad","967":"a31bf460"}[chunkId] + ".chunk.js";
};